"use client"

import { Form, Card } from "react-bootstrap"
import { RightOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"
import { Grid } from "antd"
import { useState } from "react"
import VitalsDisplay from "../patients/Vitals_display"
import { useNavigate } from "react-router-dom";
import MedicalHistory from "./medicalHistory"


const { useBreakpoint } = Grid

export default function PatientSidebar({ vitals, notes, onNotesChange,appointmentDetails,vitalRefresh }) {
  const screens = useBreakpoint()
  const [isVitalsModalVisible, setIsVitalsModalVisible] = useState(false);
  const [showMedicalHistory, setShowMedicalHistory]= useState(false)
  console.log("Appointment Details in Sidebar:", appointmentDetails)
  console.log("Vitals in Sidebar:", vitals)
  const navigate = useNavigate();


  const handleVitalsClick = () => {
    setIsVitalsModalVisible(true)
  }

  const handleVitalsClose = () => {
    setIsVitalsModalVisible(false)
    vitalRefresh(prev => !prev); // Trigger a refresh of vitals data
  }

  const handleVitalsSubmit = (formValues) => {
    console.log("Submitted Vitals Form Values:", formValues)
    setIsVitalsModalVisible(false)
  }

  // Responsive styles
  const titleStyle = {
    color: "#2e37a4",
    fontSize: screens.xs ? "clamp(0.9rem, 3vw, 1.1rem)" : "clamp(1rem, 1.5vw, 1.2rem)",
    marginBottom: 0,
  }

  const cardBodyStyle = {
    padding: screens.xs ? "8px 12px" : "10px 0px",
  }

  const vitalsContainerStyle = {
    maxHeight: screens.xs ? "200px" : "250px",
    overflowY: "auto",
    overflowX: "hidden",
  }

  const vitalRowStyle = {
    padding: screens.xs ? "0px 0px 4px 0px" : "0px 0px 6px 0px",
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
  }

  const vitalLabelStyle = {
    fontSize: screens.xs ? "0.7rem" : "0.75rem",
    minWidth: screens.xs ? "60px" : "80px",
    marginRight: "8px",
    flexShrink: 0,
  }

  const vitalInputStyle = {
    fontSize: screens.xs ? "0.7rem" : "0.875rem",
    maxWidth: screens.xs ? "80px" : "100px",
    height: screens.xs ? "28px" : "32px",
  }

  const vitalUnitStyle = {
    fontSize: screens.xs ? "0.65rem" : "0.75rem",
    minWidth: screens.xs ? "30px" : "40px",
    marginLeft: "8px",
    flexShrink: 0,
  }

  
  const textareaStyle = {
    fontSize: screens.xs ? "0.8rem" : "0.9rem",
    minHeight: screens.xs ? "60px" : "80px",
  }

  return (
    <div
      className="patient-list"
      style={{
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        height: "calc(100% - 40px)",
        scrollbarWidth: "thin",
        scrollbarColor: "#ccc transparent",
      }}
    >
      <div className="patient-details  flex-column h-100">
        {/* Medical History */}
        <Card className="border-2 rounded-0 border-bottom border-top mb-0" onClick={() => setShowMedicalHistory(true)}>
          <Card.Body style={cardBodyStyle}>
            <div className="d-flex justify-content-between align-items-center">
              <Card.Title as="h5" style={titleStyle}>
                Medical History
              </Card.Title>
              <RightOutlined
                style={{ fontSize: screens.xs ? "14px" : "16px" }}
              />
            </div>
          </Card.Body>
        </Card>
        {
          showMedicalHistory&&
          <MedicalHistory
            patientId={appointmentDetails?.patient_id}
            open={showMedicalHistory}
            onClose={() => setShowMedicalHistory(false)}
          />
        }

        {/* Vitals */}
        <Card
          className="border-2 rounded-0 border-bottom mb-0  mt-2"
          onClick={handleVitalsClick}
          style={{ cursor: "pointer" }}
        >
          <Card.Body style={cardBodyStyle}>
            <div className="d-flex justify-content-between align-items-center mb-2">
              <Card.Title as="h5" style={titleStyle}>
                Vitals
              </Card.Title>
              <RightOutlined
                style={{ fontSize: screens.xs ? "14px" : "16px" }}
              />
            </div>

            <div style={vitalsContainerStyle}>
              {vitals ? (
                <div>
                  {[
                    { name: "Pulse", value: vitals.pulse, unit: "/min" },
                    { name: "Systolic", value: vitals.systolic, unit: "mmHg" },
                    {
                      name: "Diastolic",
                      value: vitals.diastolic,
                      unit: "mmHg",
                    },
                    { name: "SPO2", value: vitals.spo2, unit: "%" },
                  ].map((vital, index) => (
                    <div
                      key={index}
                      style={vitalRowStyle}
                      className="d-flex align-items-center mb-2"
                    >
                      <span className="text-muted" style={vitalLabelStyle}>
                        {vital.name}
                      </span>
                      <Form.Control
                        type="text"
                        size="sm"
                        readOnly
                        className="flex-grow-1 mx-2"
                        style={vitalInputStyle}
                        value={vital.value || "--"}
                      />
                      <span className="text-muted" style={vitalUnitStyle}>
                        {vital.unit || "--"}
                      </span>
                    </div>
                  ))}
                </div>
              ) : (<>
                <div className="mb-3 text-center">
                          <i
                            className="fa fa-heartbeat"
                            style={{
                              fontSize: "48px",
                            }}
                          ></i>
                        </div>
                <p className="text-center" >
                  No Data
                </p>
                </>
              )}
            </div>
          </Card.Body>
        </Card>

        {/* Vitals Modal */}
        <VitalsDisplay
          isVisible={isVitalsModalVisible}
          onClose={handleVitalsClose}
          vitaldata={vitals}
          appointment_id={appointmentDetails?.appointment_id}
          patient_id={appointmentDetails?.patient_id}
        />

        {/* Prescription Notes */}
        <Card className="border-0 rounded-0 border-bottom mb-0">
          <Card.Body style={cardBodyStyle}>
            <h4 className="mb-2" style={titleStyle}>
              Prescription Notes
            </h4>
            <Form.Control
              as="textarea"
              rows={screens.xs ? 2 : 3}
              placeholder="This note is printed.."
              value={notes?.prescription_notes}
              onChange={(e) =>
                onNotesChange({
                  prescription_notes: e.target.value,
                })
              }
              style={textareaStyle}
            />
          </Card.Body>
        </Card>

        {/* Doctor Notes */}
        <Card className="border-0 rounded-0">
          <Card.Body style={cardBodyStyle}>
            <h4 className="mb-2" style={titleStyle}>
              Doctor Notes
            </h4>
            <Form.Control
              as="textarea"
              rows={screens.xs ? 2 : 3}
              placeholder="This note is not printed.."
              value={notes?.doctor_notes}
              onChange={(e) =>
                onNotesChange({
                  doctor_notes: e.target.value,
                })
              }
              style={textareaStyle}
            />
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}

PatientSidebar.propTypes = {
  vitals: PropTypes.array.isRequired,
  notes: PropTypes.object.isRequired,
  onNotesChange: PropTypes.func.isRequired,
  appointmentDetails: PropTypes.object.isRequired,
  vitalRefresh: PropTypes.func.isRequired,
}
